import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from 'new/contexts/SnackbarContext';
import { ROUTE_FLOWS } from 'new/constants/pathnames';

export const useFlowDuplicate = (flowId?: number) => {
  const { pathname } = useLocation();
  const { showSuccess } = useSnackbar();
  const [cloneFlowData, setCloneFlowData] = useState<any>(null);

  const toggleCloneFlowModal = useCallback(
    (data?: any) => {
      setCloneFlowData(
        data
          ? {
              ...data,
              nodeKey: String(data.nodeKey ?? data.flow_node_id ?? data.origin_node_id ?? flowId),
            }
          : null,
      );
    },
    [flowId],
  );

  const handleDuplicateSuccess = useCallback(
    (newFlowId: number) => {
      const flowTypeSegment = pathname.slice(ROUTE_FLOWS.length + 1).split('/')[0];
      const url = `${ROUTE_FLOWS}/${flowTypeSegment}/${newFlowId}/edit`;
      window.open(url, '_blank', 'noreferrer');
      showSuccess('Flow duplicated. Opening in new tab.');
    },
    [pathname, showSuccess],
  );

  return { cloneFlowData, toggleCloneFlowModal, handleDuplicateSuccess };
};
